import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../authContext';

/** Layer 1: is there an authenticated account at all? */
export function AuthGuard() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Remember where they were headed so sign-in can return them there.
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
